export default __webpack_public_path__ + "static/media/school-logo.12a384eb.png";